import * as net from 'util/Net';

export interface AgentFoundryCanvasPreviewResponse {
  signedUrl: string;
  // ISO 8601 timestamp string (`datetime.isoformat()` on the backend).
  expiresAt: string;
}

export function getAgentFoundryCanvasPreviewUrl(
  agentFoundryId: string,
  // Which canvas to render: 'overview', or an additional tab's system name. Always sent explicitly,
  // so the server can make the param required without breaking this caller.
  canvasTabName: string,
  filePath: string = 'index.html'
): Promise<AgentFoundryCanvasPreviewResponse> {
  return net.postJSONPromise({
    url: `/1/api/llm/agent-foundries/${agentFoundryId}:render-canvas`,
    data: {filePath, canvasTabName},
  });
}
